/*
 * Shareable patient signup links (track-typed URLs).
 *
 * Maps the slug in a track-typed signup link (`/patient/signup/<slug>`) to the
 * patient `registrationType` it presets and a human label for confirmation UI.
 * The resolved `type` values match the chooser buttons in
 * `components/PatientRegistrationType` and the values persisted by the
 * registration details-submit — they must stay in sync.
 *
 * The track is not a security boundary: it guides patients to the right intake
 * path. Unknown slugs resolve to `null` so bad links degrade to the chooser.
 */

export const SIGNUP_TRACKS = {
	iop: { type: 'iopPhp', label: 'IOP or PHP' },
	outpatient: { type: 'adult', label: 'Outpatient Adult' },
	child: { type: 'child', label: 'Teen/Child' },
};

/**
 * Resolve a link slug to its track descriptor.
 * @param {string} slug - the slug segment from the signup/sign-in link
 * @returns {{ type: string, label: string } | null} descriptor, or null when unknown/absent
 */
export const resolveSignupTrack = (slug) => {
	if (!slug) return null;
	const key = String(slug).toLowerCase();
	// Own-key check: a bare lookup would resolve prototype-chain slugs
	// (`/patient/signup/constructor`) to truthy garbage instead of null.
	if (!Object.prototype.hasOwnProperty.call(SIGNUP_TRACKS, key)) return null;
	return SIGNUP_TRACKS[key];
};
